import Alert from "./Alert"
import Icon from "./AlertIcon"

export default Object.assign(Alert, { Icon })
